import { RouteObject } from "react-router-dom";
import TarrifList from "./components/list/list";
import { CreateRate } from "./components/create/Create";
import { RateEdit } from "./components/edit/RateEdit";
import { BulkEditStepper } from "./components/bulkEdit/BulkEditStepper";
import { RateDetail } from "./components/detail/Detail";

export interface PlanRatesRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: PlanRatesRoute[];
}

export const ratesRoutes: PlanRatesRoute[] = [
  {
    path: "/plan-tarrif",
    element: <TarrifList />,
  },
  {
    path: "/plan-tarrif/tariff/:action",
    element: <CreateRate />,
  }, 
  {
    path: "/plan-tarrif/tariff/edit/:id",
    element: <RateEdit />,
  },
  {
    path: "/plan-tarrif/tariff/bulk-edit",
    element: <BulkEditStepper />,
  },
  {
    path: "/plan-tarrif/details/:id",
    element: <RateDetail />,
  },
];